import React from "react";
import cx from "classnames";
import PageFooter from "./page-footer";
import PropTypes from "prop-types";

function LayoutWithFooter({ className, children, contentClassName }) {
  return (
    <div className={cx("LayoutWithFooter", className)}>
      <div className={cx("LayoutWithFooter__Content", contentClassName)}>
        {children}
      </div>
      <PageFooter className="LayoutWithFooter__Footer" />
    </div>
  );
}

LayoutWithFooter.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default LayoutWithFooter;



// WEBPACK FOOTER //
// ./src/modules/page/layout-with-footer.js